import { useSelector } from "react-redux";
import "../../Landing.css";
import "./Favorites.css";
import { useEffect, useState, useRef } from "react";
import OnlyDown from "../../../..//Assets/Images/CommanImages/downOnly.png";
import StarSquare from "../../../../Assets/Images/CommanImages/starSquare.png";
import { Link } from "react-router-dom";
import { FULL_API_BASE_URL } from "../../../../Config/Config";
import Star3 from "./../../../../Assets/Images/CommanImages/star3.png";
import EndPoints from "../../../../Api/EndPoints";
import favoritesEvents from "../../../../Utils/favoritesEvents";

const getMenuStructureWithColors = (data) => {
  const menuMap = {};
  const menuStructure = [];
  let localRoutes = [];

  data.forEach((menuItem) => {
    if (!menuMap[menuItem.LVL1]) {
      menuMap[menuItem.LVL1] = {
        name: menuItem.LVL1,
        colors: "#ecf0f1",
        children: [],
      };
      menuStructure.push(menuMap[menuItem.LVL1]);
    }

    let level2 = menuMap[menuItem.LVL1].children.find(
      (c) => c.name === menuItem.LVL2
    );
    if (!level2) {
      level2 = {
        name: menuItem.LVL2,
        colors: "#bdc3c7",
        children: [],
      };
      menuMap[menuItem.LVL1].children.push(level2);
    }

    let level3 = level2.children.find((c) => c.name === menuItem.LVL3);
    if (!level3) {
      level3 = {
        name: menuItem.LVL3,
        colors: "#95a5a6",
      };
      level2.children.push(level3);
    }

    if (menuItem.ui_path && menuItem.ui_element) {
      const routeExists = localRoutes.some(
        (route) =>
          route.ui_path === menuItem.ui_path &&
          route.ui_element === menuItem.ui_element
      );
      if (!routeExists) {
        localRoutes.push({
          ui_path: menuItem.ui_path,
          ui_element: menuItem.ui_element,
        });
      }
      level3.ui_path = menuItem.ui_path;
      level3.ui_element = menuItem.ui_element;
    }
  });

  return { menuStructure, localRoutes };
};

const getLeafNodesWithPath = (menuStructure) => {
  const leafNodes = [];

  const traverse = (node, path) => {
    if (!node.children || node.children.length === 0) {
      if (node.ui_path && node.ui_element) {
        leafNodes.push({
          name: node.name,
          ui_path: node.ui_path,
          ui_element: node.ui_element,
          path: `${path} > ${node.name}`,
        });
      }
      return;
    }

    const currentPath = path ? `${path} > ${node.name}` : node.name;
    node.children.forEach((child) => traverse(child, currentPath));
  };

  menuStructure.forEach((item) => traverse(item, ""));
  return leafNodes;
};

function MyFavoritesDropdown({ setPagePath, dataClient }) {
  const [open, setOpen] = useState(false);
  const [favoritesData, setFavoritesData] = useState([]);
  const { data } = useSelector((state) => state.landing);
  // console.log("data", data);
  const initialFavoritesData = data?.client_schema_name?.[5] || [];
  const menuDatas = data?.client_schema_name?.[2] || [];
  const user_id = data?.client_schema_name?.[6]?.[0]?.user_id;
  const client_id = data?.client_schema_name?.[6]?.[0]?.client_id;
  const client_branch_id = data?.client_schema_name?.[6]?.[0]?.client_branch_id;

  useEffect(() => {
    if (menuDatas.length > 0) {
      const { menuStructure } = getMenuStructureWithColors(menuDatas);
      const leafNodes = getLeafNodesWithPath(menuStructure);

      const updatedFavoritesData = initialFavoritesData.map((favorite) => {
        const matchedLeafNode = leafNodes.find(
          (leafNode) => leafNode.ui_path === favorite.ui_path
        );
        return matchedLeafNode
          ? { ...favorite, path: matchedLeafNode.path }
          : favorite;
      });

      setFavoritesData(updatedFavoritesData);
    }
  }, [initialFavoritesData, menuDatas]);

  let menuRef = useRef();

  useEffect(() => {
    const handler = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, []);

  // Listen for favorite changes from sidebar menu
  useEffect(() => {
    const unsubscribeRemove = favoritesEvents.on(
      "favoriteRemoved",
      (screenId) => {
        setFavoritesData((prevFavorites) =>
          prevFavorites.filter((fav) => fav.screen_id !== screenId)
        );
      }
    );

    // When favorite is added from sidebar, fetch fresh data from API
    const unsubscribeAdd = favoritesEvents.on(
      "favoriteAdded",
      async (screenId) => {
        try {
          const response = await fetch(
            `${EndPoints.CLIENT_LANDING_PAGE_INFO_V2}?client_id=${client_id}&user_id=${user_id}&client_branch_id=${client_branch_id}`
          );
          const apiData = await response.json();
          const newFavorites = apiData?.client_schema_name?.[5] || [];

          if (menuDatas.length > 0) {
            const { menuStructure } = getMenuStructureWithColors(menuDatas);
            const leafNodes = getLeafNodesWithPath(menuStructure);
            const updatedFavorites = newFavorites.map((favorite) => {
              const matchedLeafNode = leafNodes.find(
                (leafNode) => leafNode.ui_path === favorite.ui_path
              );
              return matchedLeafNode
                ? { ...favorite, path: matchedLeafNode.path }
                : favorite;
            });
            setFavoritesData(updatedFavorites);
          }
        } catch (error) {
          console.error("Error fetching favorites:", error);
        }
      }
    );

    return () => {
      unsubscribeRemove();
      unsubscribeAdd();
    };
  }, [client_id, user_id, client_branch_id, menuDatas]);

  // const handleSelect = async (screen_id) => {
  //   const URL = `${FULL_API_BASE_URL}/manage-user-favourite?operation=delete&user_id=${user_id}&screen_id=${screen_id}&client_br_id=${client_branch_id}`;

  //   try {
  //     const response = await fetch(URL, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json; charset=UTF-8",
  //       },
  //     });

  //     if (!response.ok) {
  //       throw new Error(`Error:${response.status}`);
  //     }
  //     const result = await response.json();
  //     setFavoritesData((prevFavorites) =>
  //       prevFavorites.filter((fav) => fav.screen_id !== screen_id)
  //     );
  //   } catch (error) {
  //     console.error(error);
  //   }

  //   setOpen(false);
  // };

  const handleSelect = async (screen_id) => {
    const URL = `${FULL_API_BASE_URL}/manage-user-favourite?operation=delete&user_id=${user_id}&screen_id=${screen_id}&client_br_id=${client_branch_id}`;

    try {
      const response = await fetch(URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      });

      if (!response.ok) {
        throw new Error(`Error:${response.status}`);
      }
      const result = await response.json();
      setFavoritesData((prevFavorites) =>
        prevFavorites.filter((fav) => fav.screen_id !== screen_id)
      );
      // ADD THIS LINE - Emit event to sync sidebar menu items
      favoritesEvents.removeFavorite(screen_id);
    } catch (error) {
      console.error(error);
    }

    setOpen(false);
  };

  // Function to refresh favorites data from the API
  const refreshFavorites = async () => {
    console.log("Refreshing favorites data...");

    try {
      const response = await fetch(
        // `${FULL_API_BASE_URL}/client_landing_page_info_web/?client_id=${client_id}&user_id=${user_id}`
        `${EndPoints.CLIENT_LANDING_PAGE_INFO_V2}?client_id=${client_id}&user_id=${user_id}&client_branch_id=${client_branch_id}`
      );
      const apiData = await response.json();

      // Assuming the favorites are in the same location in the new API response
      const newFavorites = apiData?.client_schema_name?.[5] || [];

      // Re-run the path logic on the new data
      if (menuDatas.length > 0) {
        const { menuStructure } = getMenuStructureWithColors(menuDatas);
        const leafNodes = getLeafNodesWithPath(menuStructure);
        const updatedFavorites = newFavorites.map((favorite) => {
          const matchedLeafNode = leafNodes.find(
            (leafNode) => leafNode.ui_path === favorite.ui_path
          );
          return matchedLeafNode
            ? { ...favorite, path: matchedLeafNode.path }
            : favorite;
        });
        setFavoritesData(updatedFavorites);
      }
    } catch (error) {
      console.error("Error refreshing favorites:", error);
    }
  };

  return (
    <div className="myfav-menu-container" ref={menuRef}>
      <div
        className="myfav-menu-trigger"
        onClick={() => {
          if (!open) {
            // Refresh data only when opening the dropdown
            refreshFavorites();
          }
          setOpen(!open);
        }}
      >
        <img
          style={{
            height: "24px",
            width: "24px",
            lineHeight: "14px",
            marginRight: "8px",
          }}
          src={StarSquare}
          alt="star"
        />
        <p style={{ lineHeight: "14px", marginTop: "5px" }}>My Favourite</p>
        <img
          style={{
            height: "8px ",
            width: "10px",
            marginLeft: "8px",
            lineHeight: "14px",
            marginTop: "8px",
          }}
          src={OnlyDown}
          alt="down"
        />
      </div>

      <div
        className={`favorites-dropdown-menu ${open ? "active" : "inactive"}`}
        style={{ zIndex: "2000" }}
      >
        <div className="list">
          {favoritesData.length > 0 ? (
            favoritesData.map((fav, index) => (
              <li
                key={index}
                className="favorites-dropdownItem"
                onClick={() => setOpen(false)}
              >
                <Link
                  to={fav.ui_path}
                  className="myfav-link"
                  style={{ display: "flex", width: "280px" }}
                  onClick={() => setPagePath(fav.path)}
                >
                  <p className="fav-name">{fav.display_name}</p>
                  {/* <p>{fav.path}</p> */}
                  {/* <div
                    className="starsprite"
                    onClick={() => handleSelect(fav.screen_id)}
                  ></div> */}
                  <img
                    className="starsprite"
                    src={Star3}
                    alt=""
                    onClick={() => handleSelect(fav.screen_id)}
                  />
                </Link>
              </li>
            ))
          ) : (
            <li
              className="favorites-dropdownItem"
              onClick={() => setOpen(false)}
            >
              <p>No Data</p>
            </li>
          )}
        </div>
      </div>
    </div>
  );
}

function DropdownItem(props) {
  return (
    <li
      className="favorites-dropdownItem"
      onClick={() => props.onSelect(props.text)}
    >
      <p>{props.text}</p>
      <div className="starsprite"></div>
    </li>
  );
}

export default MyFavoritesDropdown;

// ===========================================================================================
// SHASHI USING REDUX IN FAVORITES

// import { useSelector, useDispatch } from "react-redux";
// import "../../Landing.css";
// import "./Favorites.css";
// import { useEffect, useState, useRef } from "react";
// import OnlyDown from "../../../..//Assets/Images/CommanImages/downOnly.png";
// import StarSquare from "../../../../Assets/Images/CommanImages/starSquare.png";
// import Star3 from "./../../../../Assets/Images/CommanImages/star3.png";
// import { Link } from "react-router-dom";
// import { toggleFavorite } from "../../../../Redux/Fav/FavSlice"; // Import the thunk

// function MyFavoritesDropdown({ setPagePath }) {
//   const [open, setOpen] = useState(false);
//   const dispatch = useDispatch();

//   // Get favorites data from Redux
//   const favoritesData = useSelector((state) => state.fav.data);
//   const { data } = useSelector((state) => state.landing);

//   const userId = data?.client_schema_name?.[6]?.[0]?.user_id;
//   const clientBrId = data?.client_schema_name?.[6]?.[0]?.client_branch_id;

//   let menuRef = useRef();

//   useEffect(() => {
//     const handler = (e) => {
//       if (menuRef.current && !menuRef.current.contains(e.target)) {
//         setOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handler);

//     return () => {
//       document.removeEventListener("mousedown", handler);
//     };
//   }, []);

//   const handleSelect = (screen_id, isFavorite) => {
//     // Dispatch toggleFavorite thunk to update the Redux state
//     dispatch(toggleFavorite({ userId, clientBrId, screen_id, isFavorite }));
//   };

//   return (
//     <div className="myfav-menu-container" ref={menuRef}>
//       <div
//         className="myfav-menu-trigger"
//         onClick={() => {
//           setOpen(!open);
//         }}
//       >
//         <img
//           style={{
//             height: "24px",
//             width: "24px",
//             lineHeight: "14px",
//             marginRight: "8px",
//           }}
//           src={StarSquare}
//           alt="star"
//         />
//         <p style={{ lineHeight: "14px", marginTop: "5px" }}>My Favourite</p>
//         <img
//           style={{
//             height: "8px ",
//             width: "10px",
//             marginLeft: "8px",
//             lineHeight: "14px",
//             marginTop: "8px",
//           }}
//           src={OnlyDown}
//           alt="down"
//         />
//       </div>

//       <div
//         className={`favorites-dropdown-menu ${open ? "active" : "inactive"}`}
//         style={{ zIndex: "2000" }}
//       >
//         <div className="list">
//           {favoritesData.length > 0 ? (
//             favoritesData.map((fav, index) => (
//               <li
//                 key={index}
//                 className="favorites-dropdownItem"
//                 onClick={() => setOpen(false)}
//               >
//                 <Link
//                   to={fav.ui_path || "#"} // Use "#" if ui_path is missing
//                   className="myfav-link"
//                   style={{ display: "flex", width: "280px" }}
//                   onClick={() => setPagePath(fav.path)}
//                 >
//                   <p className="fav-name">{fav.display_name || fav.name}</p>
//                   <img
//                     className="starsprite"
//                     src={Star3}
//                     alt="Remove from favorites"
//                     onClick={(e) => {
//                       e.preventDefault(); // Prevent link navigation
//                       handleSelect(fav.screen_id, true); // Pass true to indicate removal
//                     }}
//                   />
//                 </Link>
//               </li>
//             ))
//           ) : (
//             <li
//               className="favorites-dropdownItem"
//               onClick={() => setOpen(false)}
//             >
//               <p>No Data</p>
//             </li>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default MyFavoritesDropdown;

// ===========================================================================================
